module.exports = __webpack_public_path__ + "static/bkash-gateway-1cd011c3947d24ed52057f9c5f783579.png";